if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.initSplideBindings();

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      initSplideBindings() {
        const maxAttempts = 60;
        let attempts = 0;

        const bind = () => {
          attempts += 1;

          if (!this.elements.viewer) return;

          const viewerSplide = this.elements.viewer.__splide;
          if (!viewerSplide) {
            if (attempts < maxAttempts) requestAnimationFrame(bind);
            return;
          }

          if (this.__splideBound) return;
          this.__splideBound = true;

          const syncThumbsToViewer = () => {
            if (!this.elements.thumbnails) return;

            const thumbsSplide = this.elements.thumbnails.__splide;
            if (thumbsSplide) {
              thumbsSplide.go(viewerSplide.index);
            }

            const slides = Array.from(this.elements.viewer.querySelectorAll('.splide__slide[data-media-id]'));
            const activeSlide = slides[viewerSplide.index];
            if (!activeSlide) return;

            const thumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${activeSlide.dataset.mediaId}"]`
            );
            this.setActiveThumbnail(thumbnail);
          };

          viewerSplide.on('mounted moved', syncThumbsToViewer);
        };

        requestAnimationFrame(bind);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // Usar seletor mais específico para pegar apenas os slides do Splide
        const activeMedia =
          this.elements.viewer.querySelector(`.splide__slide[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('.splide__slide[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('.splide__slide[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        const viewerSplide = this.elements.viewer?.__splide;

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (viewerSplide) viewerSplide.refresh();
          if (this.elements.thumbnails?.__splide) this.elements.thumbnails.__splide.refresh();
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        if (viewerSplide) {
          const slides = Array.from(this.elements.viewer.querySelectorAll('.splide__slide[data-media-id]'));
          const index = slides.findIndex((el) => el.dataset.mediaId === activeMedia.dataset.mediaId);
          if (index >= 0) viewerSplide.go(index);
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!viewerSplide && (!this.mql.matches || this.elements.thumbnails)) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        const thumbsSplide = this.elements.thumbnails.__splide;
        if (thumbsSplide) {
          const slides = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
          const index = slides.findIndex((el) => el.dataset.target === thumbnail.dataset.target);
          if (index >= 0) thumbsSplide.go(index);
          return;
        }

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
